import type { QueriesOptions} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { getAllPrograms, getProgram, indexProgramsByClientId } from "~/modules/project/api/program/programApiDispatchers.ts";

const ENTITY_QUERY_KEY = "program";

export const ALL_PROGRAMS_QUERY_KEY = [ENTITY_QUERY_KEY, "all"];
export const PROGRAM_QUERY_KEY = (programId: string) => [ENTITY_QUERY_KEY, programId];
export const PROGRAMS_BY_CLIENT_QUERY_KEY = (clientId: string) => [ENTITY_QUERY_KEY, clientId];

export const useProgram = (clientId: string, programId: string, options?: QueriesOptions<any>) => useQuery({
    queryKey: PROGRAM_QUERY_KEY(programId),
    queryFn: () => getProgram(clientId, programId).then(getDataFromResponse),
	...options,
});

export const useAllPrograms = () => useQuery({
    queryKey: ALL_PROGRAMS_QUERY_KEY,
    queryFn: () => getAllPrograms().then(getDataFromResponse)
});

export const useClientsPrograms = (clientId: string, options?: QueriesOptions<any>) => useQuery({
    queryKey: PROGRAMS_BY_CLIENT_QUERY_KEY(clientId),
    queryFn: () => indexProgramsByClientId(clientId).then(getDataFromResponse),
	...options,
});